import React from "react";
import logoBlack from "../assets/logo-black.png";
// import { AiOutlineDown, AiOutlineUp } from "react-icons/ai";

const TermsAndConditions = () => {
  return (
    <div style={styles.page}>
      {/* ✅ HEADER */}
      <div style={styles.header}>
        <img
          src={logoBlack}
          alt="Conquer Life Logo"
          style={styles.logo}
        />
        <h1 style={styles.headerTitle} className="text-big-heading">CONQUER LIFE</h1>
      </div>
      {/* ✅ CONTENT */}
      <div style={styles.container}>
        <h1 style={styles.heading} className="text-big-heading">Terms & Conditions</h1>
        <p className="text-body">
          Welcome to Terms and Conditions of Use (these “Terms”) of the Conquer
          Life Company (the “Conquer Life Co.”). This is a contract between you
          and Conquer Life Co. (the “Company”) and we want you to understand
          your rights and our rights before using the Conquer Life website or
          application (the “App”). Please take a moment to read these Terms
          carefully before using the App. By accessing, viewing, or using the
          App, you agree to be legally bound by these Terms. Please also review
          our Community Guidelines and our Privacy Policy, which form part of
          these Terms.
        </p>

        <p className="text-body">
          <b>Subscription and Renewal</b>
          <br></br>
          Please note that, currently, Conquer Life does not offer any
          subscription plans for its App. If any subscription services become
          available in the future, the terms of such services will be detailed
          in the relevant sections of these Terms.
        </p>

        <p className="text-body">
          <b>Dispute Resolution and Arbitration</b>
          <br></br>
          The Disputes Resolution section of these Terms contains provisions for
          resolving disputes between you and the Company. It includes an
          arbitration agreement that will, with limited exceptions, require
          disputes to be submitted to binding and final arbitration. You have
          the right to opt out of the arbitration agreement pursuant to the
          Disputes Resolution section. If you do not opt out,
          <ol>
            <li>
              you will be able to pursue claims and seek relief against us only
              on an individual basis; and
            </li>
            <li>
              you are waiving your right to seek relief in court or to have a
              jury trial for your claims.
            </li>
          </ol>
        </p>

        <p className="text-body">
          <b>Cancellation and Refunds</b>
          <br></br>
          As there are no subscription plans available for Conquer Life at this
          time, the cancellation and refund policies related to subscriptions do
          not apply. If any subscription services are introduced in the future,
          detailed information on cancellation and refund procedures will be
          provided at that time.
        </p>

        <h3 className="text-sub-heading">I. Conquer Life Rules</h3>

        <p className="text-body">
          <b>Account Registration and Age Requirements</b>
          <br></br>
          To use the Conquer Life app, you must:
          <ul>
            <li>Be at least 18 years old; and</li>
            <li>
              Be legally permitted to use the app by the laws of your home
              country.
            </li>
          </ul>
          We monitor for underage use and will take necessary actions if we
          believe you may be underage.
        </p>

        <p className="text-body">
          <b>Account Creation and Access</b>
          <br></br>
          You can create an account solely through our app interface. We do not
          integrate with external social media platforms such as Facebook. This
          is to ensure users have safe and private conversations within the app.
          Users interact using usernames.
          <br></br>
          <br></br>
          You cannot use another person’s account or share your account with
          anyone else without permission.
        </p>

        <p className="text-body">
          <b> Account Deletion</b>
          <br></br>
          You can delete your account at any time by going to the ‘Settings’
          page and clicking on the ‘Delete account’ link. Once you delete your
          account, your access ends and your contact and profile information is
          removed, except for your profile color. Deletion disables activity
          reminders and cancels pending kindness-coin notification forwarding.
          A reminder already being sent cannot be recalled. Limited notification
          records, user-linked identifiers, and delivery history remain in the
          backend for notification processing, troubleshooting, and duplicate
          prevention. For more information, please refer to our Privacy Policy.
          If you sign up again shortly after deleting your account, it will be
          treated as a new account, and we will not recover or reinstate your
          old account.
        </p>

        <p className="text-body">
          <b>Monitoring and Enforcement</b>
          <br></br>
          We use a combination of automated systems, user reports, and a
          dedicated team of human moderators to proactively monitor and review
          all user-generated content—including profiles, messages, and group
          interactions—to enforce these Terms and our Community Guidelines.
          Users can report content or other users directly within the app at any
          time. All reports are reviewed promptly, and appropriate enforcement
          actions are taken, which may include warnings, temporary restrictions,
          or permanent bans. Users may also block other users and leave or end
          any chat at any time. We reserve the right to:
          <ul>
            <li>Terminate or suspend any account;</li>
            <li>Restrict access to the app;</li>
            <li>
              Use any available means to enforce the Terms, including
              restricting access from certain devices, accounts, or IP
              addresses.
            </li>
          </ul>
          For users residing in the European Union (EU), we will notify you if
          we take action against your account or content unless prohibited by
          law enforcement. For all other users, we may take action without prior
          notice and without liability. This includes, but is not limited to,
          termination or suspension of your account if we determine, in our sole
          discretion, that your conduct is inappropriate or violates these
          Terms.
        </p>

        <p className="text-body">
          <b>User-Generated Content and Safety</b>
          <br></br>
          Conquer Life includes user-generated content such as profile
          information, messages, and group chat interactions. To maintain a safe
          environment, we employ both automated moderation tools and human
          review to detect and address content that violates our Community
          Guidelines. Users have the ability to: report objectionable content or
          users directly within the app; block users to prevent further contact;
          and leave or end any conversation at any time. Reports are reviewed in
          a timely manner, and enforcement actions—including warnings, content
          removal, temporary restrictions, or permanent account bans—are applied
          as appropriate. For support, users may contact us at
          info@conquerlife.io or through the in-app Feedback section (Menu →
          Settings → Feedback).
        </p>

        <p className="text-body">
          <b>User Rights and Appeals</b>
          <br></br>
          If your account is terminated or suspended, you will not receive a
          refund for any paid services or features already charged. If you
          believe we have made a mistake, you can appeal using the processes
          outlined within the app or by contacting us through our contact form.
          <br></br>
          <br></br>
          For users in the EU, you have additional rights under the Digital
          Services Act, including access to third-party dispute settlement
          processes and the right to seek remedies from the courts in your EU
          member state. Users in the UK have the right to bring a claim for
          breach of contract if you believe we have breached these Terms.
        </p>
        <p className="text-body">
          <b>Access and Use</b>
          <br></br>
          You may not access, tamper with, or use non-public areas of the app or
          our systems without authorization. Certain portions of the app may not
          be accessible if you have not registered for an account.
        </p>

        <h2 className="text-heading">II. Types Of Content</h2>
        <p className="text-body">
          On the Conquer Life app, the content you encounter falls into two main
          categories:
          <ul>
            <li>
              Content Provided by Users: This includes user profile details that
              are visible on the app.
            </li>
            <li>
              Content Provided by Conquer Life: This encompasses all other
              content related to the app, including app features, interface
              elements, and any proprietary materials created by Conquer Life.
            </li>
          </ul>
        </p>
        <p className="text-body">
          <b>Content Restrictions</b>
          <br></br>
          We want to foster a positive and respectful environment on Conquer
          Life. To this end, we impose restrictions on certain types of content
          that:
          <ul>
            <li>
              Are illegal or encourage, promote, or incite any illegal activity;
            </li>
            <li>Are harmful to minors;</li>
            <li>Are defamatory or libelous;</li>
            <li>
              Infringe any third party’s rights (including, without limitation,
              intellectual property rights and privacy rights);
            </li>
            <li>Show another person without their consent;</li>
            <li>
              Contain language or imagery that could be deemed offensive or
              likely to harass, upset, embarrass, alarm, or annoy any other
              person;
            </li>
            <li>
              Are obscene, pornographic, violent, or otherwise may offend human
              dignity;
            </li>
            <li>
              Are abusive, insulting, or threatening, discriminatory, or promote
              or encourage racism, sexism, hatred, or bigotry;
            </li>
            <li>
              Relate to commercial activities (including, without limitation,
              sales, competitions, and advertising, links to other websites or
              premium line telephone numbers);
            </li>
            <li>Involve the transmission of “junk” mail or “spam”;</li>
            <li>
              Impersonate or intend to deceive or manipulate a person
              (including, without limitation, scams and inauthentic behavior);
            </li>
            <li>
              Contain any spyware, adware, viruses, corrupt files, worm
              programs, or other malicious code designed to interrupt, damage,
              or limit the functionality of or disrupt any software, hardware,
              telecommunications, networks, servers, or other equipment, Trojan
              horses, or any other material designed to damage, interfere with,
              wrongly intercept, or expropriate any data or personal information
              whether from Conquer Life or otherwise; or
            </li>
            <li>Otherwise violate our Community Guidelines.</li>
          </ul>
        </p>
        <p className="text-body">
          <b>Your Content</b>
          <br></br>
          Since Conquer Life does not allow users to upload additional content
          beyond profile details, you are only responsible for ensuring that the
          information you provide in your profile complies with our Community
          Guidelines. You must ensure that any content provided does not
          infringe upon third-party rights or violate our guidelines.
        </p>
        <p className="text-body">
          <b>Member Content</b>
          <br></br>
          Other users will only share profile information visible on the app.
          You do not have rights over other users' profile information, and you
          may only use it in alignment with Conquer Life’s purpose of
          facilitating interactions between users. Misuse of other users’
          information, including for commercial purposes, spam, harassment, or
          unlawful threats, is strictly prohibited and may result in account
          termination.
        </p>
        <p className="text-body">
          <b>Our Content</b>
          <br></br>
          All other content related to the Conquer Life app, including text,
          graphics, user interfaces, trademarks, logos, sounds, artwork, and
          intellectual property, is owned, controlled, or licensed by us. You
          are granted a non-exclusive, limited, personal, non-transferable,
          revocable license to access and use Our Content under the following
          conditions:
          <ul>
            <li>
              You shall not use, sell, modify, or distribute Our Content except
              as permitted by the functionality of the app;
            </li>
            <li>
              You shall not use our name in metatags, keywords, and/or hidden
              text;
            </li>
            <li>
              You shall not create derivative works from Our Content or scrape,
              disable, decompile, analyze, or commercially exploit Our Content,
              in whole or in part;
            </li>
            <li>You shall use Our Content for lawful purposes only.</li>
          </ul>
        </p>
        <p className="text-body">
          <b>No Obligation to Pre-Screen Content</b>
          <br></br>
          While we do not have an obligation to pre-screen any content, we
          reserve the right to review, pre-screen, refuse, and/or remove any
          content, including user profile details, to maintain the safety and
          integrity of the app.
        </p>
        <p className="text-body">
          <b>Use of Recommender Systems</b>
          <br></br>
          We use algorithms to match users based on profile details and
          activity. You can learn more about our use of these systems and the
          parameters we use in our Privacy Policy.
        </p>

        <h2 className="text-heading">III. Restrictions On The App</h2>
        <p className="text-body">
          You agree to:
          <ul>
            <li>
              Comply with all applicable laws, including, without limitation,
              privacy laws, intellectual property laws, anti-spam laws, equal
              opportunity laws, and regulatory requirements;
            </li>
            <li>
              Provide accurate information, including your real age, and use a
              username you feel comfortable with on the platform. You must not
              impersonate others.
            </li>

            <li>
              Use the services in a safe, inclusive, and respectful manner and
              adhere to our Community Guidelines at all times.
            </li>
          </ul>
          You agree that you will not:
          <ul>
            <li>
              Act in an unlawful or disrespectful manner, including being
              dishonest, abusive, or discriminatory;
            </li>
            <li>
              Misrepresent your identity, your age, your current or previous
              positions, qualifications, or affiliations with a person or
              entity;
            </li>
            <li>
              Disclose information that you do not have the consent to disclose;
            </li>
            <li>Stalk or harass any other user of the App;</li>
            <li>
              Use the App in any deceptive, inauthentic, or manipulative way,
              including engaging in conduct or distributing content related to
              scams, spam, inauthentic profiles, or commercial and promotional
              activity;
            </li>
            <li>
              Submit appeals, reports, notices, or complaints that are
              manifestly unfounded;
            </li>
            <li>
              Develop, support, or use software, devices, scripts, robots, other
              types of mobile code, or any other means or processes (including
              crawlers, browser plugins, and add-ons or other technology) to
              scrape or otherwise exfiltrate from Conquer Life or its services,
              or otherwise copy profiles and other data from the services.
            </li>
          </ul>
          We do not tolerate misbehavior in the Conquer Life community. You can
          report any abuse or complaints about Member Content by contacting us,
          outlining the abuse and/or complaint. You can also report a user
          directly from a profile or in chat by clicking the ‘Block & Report’
          link. We reserve the right to investigate any possible violations of
          these Terms, any Conquer Life user’s rights, or any third-party
          rights, and we may, in our sole discretion, immediately terminate any
          user’s right to use the App without prior notice, as set out further
          above, and/or remove any improper, infringing, or otherwise
          unauthorized Member Content submitted to the App.
          <br></br>
          <br></br>
          We do not control any of the things our users say or do, so you are
          solely responsible for your interactions with other users of the App.
          <br></br>
          <br></br>
          <b>Background Checks:</b> At present, Conquer Life does not conduct
          criminal background checks on its users. While we may investigate
          reports of misconduct, we do not guarantee a comprehensive review of
          users' criminal histories. Any checks performed are not a perfect
          safety solution and may not cover all types of criminal records or
          offenses.
          <br></br>
          <br></br>
          You agree to, and hereby do, release Conquer Life and its successors
          from any claims, demands, losses, damages, rights, and actions of any
          kind, including personal injuries, death, and property damage, that
          either directly or indirectly arises from your interactions with or
          conduct of other users of the App. If you are a California resident,
          you hereby waive California Civil Code Section 1542, which states, “A
          general release does not extend to claims that the creditor or
          releasing party does not know or suspect to exist in his or her favor
          at the time of executing the release and that, if known by him or her,
          would have materially affected his or her settlement with the debtor
          or released party.” The foregoing release does not apply to any
          claims, demands, or any losses, damages, rights, and actions of any
          kind, including personal injuries, death, or property damage for any
          unconscionable commercial practice by Conquer Life or for such party’s
          fraud, deception, false promise, misrepresentation, or concealment,
          suppression, or omission of any material fact in connection with the
          App.
          <br></br>
          <br></br>
          Scraping or replicating any part of the App without our prior consent
          is expressly prohibited. This includes by any means (automated or
          otherwise) other than through our currently available, published
          interfaces, unless you have been specifically allowed to do so in a
          separate agreement with us.
        </p>

        <h2 className="text-heading">IV. Privacy</h2>
        <p className="text-body">
          For information about how Conquer Life collects, uses, and shares your
          personal data, please refer to our Privacy Policy. By using the
          Conquer Life app, you acknowledge that we may use your data in
          accordance with our Privacy Policy.
        </p>

        <h2 className="text-heading">V. Payment Terms</h2>
        <p className="text-body">
          Currently, Conquer Life does not offer any in-app purchases,
          subscriptions, or payment options within the App. As such, there are
          no charges, subscription plans, or payment actions associated with the
          use of the Conquer Life app at this time.
          <br></br>
          <br></br>
          If Conquer Life introduces any subscription plans or payment options
          in the future, this section will be updated accordingly to include
          details about payment methods, subscriptions, cancellation, refunds,
          and any applicable taxes.
          <br></br>
          <br></br>
          For now, no payments are required or processed within the Conquer Life
          app.
        </p>

        <h2 className="text-heading">VI. Virtual Items</h2>
        <p className="text-body">
          Currently, the Conquer Life app does not offer any options for
          purchasing virtual items or accessing special limited-use features.
          Therefore, no Virtual Items are available for purchase through the App
          or its partners.
          <br></br>
          <br></br>
          If in the future Conquer Life introduces the ability to purchase
          virtual items, this section will be updated accordingly to reflect the
          terms and conditions associated with such purchases. However, at this
          time, there are no purchase options, and no virtual items are offered
          for purchase within the Conquer Life app.
        </p>

        <h2 className="text-heading">VII. Notifications and Communications</h2>
        <p className="text-body">
          <b>Activity Reminders</b>
          <br></br>
          Conquer Life provides activity reminders for unread breakout messages,
          unread one-on-one and group chat messages, and kindness coins gifted
          by another user. Challenge rewards, signup rewards, and other
          system-earned coins are excluded from these reminders.
          <br></br>
          <br></br>
          The delivery channel depends on the verified contact associated with
          your account: email for an email-registered account, or SMS for an
          account registered with a supported U.S. phone number. Users currently
          register with one contact type; Settings does not provide a choice to
          switch between email and SMS.
          <br></br>
          <br></br>
          Eligible activity across these features is grouped into a combined
          reminder. The first reminder generally waits five minutes after new
          eligible activity. Later reminders are limited to once per hour when
          new eligible activity arrives; new activity after an idle period
          generally also waits five minutes. These are processing intervals,
          not guaranteed delivery times. Delivery may be delayed or unavailable.
        </p>
        <p className="text-body">
          <b>Activity Reminder Controls</b>
          <br></br>
          Settings includes a master notification switch for email/SMS activity
          reminders and individual switches for breakout messages, one-on-one
          and group chats, and kindness coins. Turning the master switch off
          stops all three types of activity reminders and saves your individual
          choices. The individual switches control which activity is included
          when the master switch is on. These controls apply separately from
          in-app notifications, push notifications, and login or security
          messages, including one-time passwords (OTPs). Turning activity
          reminders off in Settings does not disable OTPs.
        </p>
        <p className="text-body">
          <b>SMS Delivery and Opt-Out</b>
          <br></br>
          Message and data rates may apply. To stop SMS messages, reply STOP to
          the number that sent the message. A STOP request may also block OTPs
          and other messages sent from the same number. AWS or mobile carriers
          may enforce this block separately from your saved Settings choices;
          replying STOP does not automatically change the switches shown in
          Settings. Turning reminders back on in Settings cannot override an
          AWS or carrier STOP block. Any START or UNSTOP process depends on the
          provider and carrier and does not guarantee immediate restoration of
          delivery. For help, contact{" "}
          <a href="mailto:info@conquerlife.io">info@conquerlife.io</a>.
        </p>
        <p className="text-body">
          <b>Push Notifications and Other Communications</b>
          <br></br>
          The App requests your device’s permission for push notifications. If
          you deny permission, you will not receive push notifications; if you
          grant permission, the App may send them. You can change push
          permissions in your device’s notification settings and use available
          in-app notification and chat mute controls independently of email/SMS
          activity reminders.
          <br></br>
          <br></br>
          Currently, the App does not offer push notifications for offers,
          products, events, or other promotions. We may also send app feature
          updates, security updates, and necessary account communications.
          <br></br>
          <br></br>
          These disclosures describe notification behavior and controls; they
          do not request or establish consent to activity-reminder SMS.
          Permission for login or verification OTPs is separate from permission
          for activity reminders. Signing up, logging in, verifying a phone
          number, accepting these Terms, or a default-on Settings switch does
          not establish that separate permission. The App has not implemented
          a separate activity-reminder SMS opt-in, and this document update
          does not collect permission or supply it retroactively.
        </p>

        <h2 className="text-heading">VIII. Location Based Features</h2>
        <p className="text-body">
          Currently, the Conquer Life App does not use location information. In
          the future, we may introduce features that allow access to or make
          available opportunities for you to view certain content and receive
          other products, services, and/or materials based on your location. If
          such features are introduced, the App will determine your location
          using one or more reference points, such as GPS, Bluetooth, and/or
          software within your mobile device. If you have set your mobile device
          to disable GPS, Bluetooth, or other location-determining software or
          do not authorize the App to access your location data, you will not be
          able to access such location-specific content, products, services, and
          materials. We will keep the Privacy Policy and Terms and Conditions of
          Use document updated with any future changes related to location-based
          features.
        </p>

        <h2 className="text-heading">IX. Disclaimer</h2>
        <p className="text-body">
          THE APP, SITE, OUR CONTENT, AND USER CONTENT ARE ALL PROVIDED TO YOU
          “AS IS” AND “AS AVAILABLE” WITHOUT WARRANTY OF ANY KIND, EITHER
          EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO, FITNESS FOR A
          PARTICULAR PURPOSE, TITLE, OR NON-INFRINGEMENT. WITHOUT LIMITING THE
          FOREGOING, WE DO NOT GUARANTEE THE COMPATIBILITY OF ANY CONNECTIONS OR
          MATCHES.
          <br></br>
          <br></br>
          SHOULD APPLICABLE LAW NOT PERMIT THE FOREGOING EXCLUSION OF EXPRESS OR
          IMPLIED WARRANTIES, THEN WE GRANT THE MINIMUM EXPRESS OR IMPLIED
          WARRANTY REQUIRED BY APPLICABLE LAW. NO ADVICE OR INFORMATION, WHETHER
          ORAL OR WRITTEN, SHALL CREATE ANY WARRANTY, REPRESENTATION, OR
          GUARANTEE NOT EXPRESSLY STATED IN THIS SECTION.
          <br></br>
          <br></br>
          ADDITIONALLY, WE DO NOT MAKE ANY WARRANTIES THAT THE APP OR SITE WILL
          BE UNINTERRUPTED, SECURE, OR ERROR-FREE OR THAT YOUR USE OF THE APP OR
          SITE WILL MEET YOUR EXPECTATIONS, OR THAT THE APP, SITE, OUR CONTENT,
          ANY USER CONTENT, OR ANY PORTION THEREOF, IS CORRECT, ACCURATE, OR
          RELIABLE. YOUR USE OF THE APP OR SITE IS AT YOUR OWN RISK. YOU ARE
          SOLELY RESPONSIBLE FOR YOUR INTERACTIONS WITH OTHER USERS. CONQUER
          LIFE CO. IS NOT RESPONSIBLE FOR THE CONDUCT OF ANY USER. CONQUER LIFE
          CO. DOES NOT CONDUCT CRIMINAL BACKGROUND CHECKS ON ITS USERS.
        </p>

        <h2 className="text-heading"> X. Limitation Of Liability</h2>
        <p className="text-body">
          NEITHER CONQUER LIFE CO. NOR ANY OWNER WILL BE LIABLE FOR ANY DAMAGES,
          DIRECT, INDIRECT, INCIDENTAL, CONSEQUENTIAL, SPECIAL, OR PUNITIVE,
          INCLUDING, WITHOUT LIMITATION, LOSS OF DATA, INCOME, PROFIT, OR
          GOODWILL, LOSS OF OR DAMAGE TO PROPERTY, AND CLAIMS OF THIRD PARTIES
          ARISING OUT OF YOUR ACCESS TO OR USE OF THE APP, SITE, OUR CONTENT, OR
          ANY USER CONTENT, HOWEVER CAUSED, WHETHER BASED ON BREACH OF CONTRACT,
          TORT (INCLUDING NEGLIGENCE), PROPRIETARY RIGHTS INFRINGEMENT, PRODUCT
          LIABILITY, OR OTHERWISE.
          <br></br>
          <br></br>
          THE FOREGOING SHALL APPLY EVEN IF WE WERE ADVISED OF THE POSSIBILITY
          OF SUCH DAMAGES. IF YOU BECOME DISSATISFIED IN ANY WAY WITH THE APP OR
          SITE, YOUR SOLE AND EXCLUSIVE REMEDY IS TO STOP YOUR USE OF THE APP
          AND SITE.
          <br></br>
          <br></br>
          YOU HEREBY WAIVE ANY AND ALL CLAIMS ARISING OUT OF YOUR USE OF THE APP
          OR SITE. BECAUSE SOME STATES DO NOT ALLOW THE DISCLAIMER OF IMPLIED
          WARRANTIES OR THE EXCLUSION OR LIMITATION OF CERTAIN TYPES OF DAMAGES,
          THESE PROVISIONS MAY NOT APPLY TO YOU. IF ANY PORTION OF THIS
          LIMITATION ON LIABILITY IS FOUND TO BE INVALID OR UNENFORCEABLE FOR
          ANY REASON, THEN OUR AGGREGATE LIABILITY SHALL NOT EXCEED ONE HUNDRED
          DOLLARS ($100).
          <br></br>
          <br></br>
          THE LIMITATION OF LIABILITY HEREIN IS A FUNDAMENTAL ELEMENT OF THE
          BASIS OF THE BARGAIN AND REFLECTS A FAIR ALLOCATION OF RISK. THE APP
          AND SITE WOULD NOT BE PROVIDED WITHOUT SUCH LIMITATIONS, AND YOU AGREE
          THAT THE LIMITATIONS AND EXCLUSIONS OF LIABILITY, DISCLAIMERS, AND
          EXCLUSIVE REMEDIES SPECIFIED HEREIN WILL SURVIVE EVEN IF FOUND TO HAVE
          FAILED IN THEIR ESSENTIAL PURPOSE. THE FOREGOING DOES NOT APPLY TO
          LIABILITY ARISING FROM ANY FRAUD OR FRAUDULENT MISREPRESENTATIONS OR
          ANY OTHER LIABILITY THAT CANNOT BE LIMITED BY APPLICABLE LAW.
        </p>

        <h2 className="text-heading">XI. Indemnity</h2>
        <p className="text-body">
          All the actions you take and the information you post on the Conquer
          Life app remain your responsibility. Therefore, you agree to
          indemnify, defend, release, and hold Conquer Life Co., along with our
          partners, licensors, affiliates, contractors, officers, directors,
          employees, representatives, and agents, harmless from and against any
          third-party claims, damages (actual and/or consequential), actions,
          proceedings, demands, losses, liabilities, costs, and expenses
          (including reasonable legal fees) suffered or reasonably incurred by
          us arising as a result of, or in connection with:
          <ul>
            <li>
              Any negligent acts, omissions, or willful misconduct by you;
            </li>
            <li>Your access to and use of the Conquer Life app;</li>
            <li>
              The uploading or submission of Content to the Conquer Life app by
              you;
            </li>
            <li>Any breach of these Terms by you; and/or</li>
            <li>
              Your violation of any law or of any rights of any third party.
            </li>
          </ul>
          We retain the exclusive right to settle, compromise, and pay any and
          all claims or causes of action that are brought against us without
          your prior consent. If we ask, you will cooperate fully and reasonably
          as required by us in the defense of any relevant claim.
          <br></br>
          <br></br>
          The foregoing provision does not require you to indemnify Conquer Life
          Co. for any unconscionable commercial practice or any fraud,
          deception, false promise, misrepresentation, or concealment,
          suppression, or omission of any material fact in connection with the
          app.
        </p>

        <h2 className="text-heading">XII. Procedure For Making Claims Of Copyright Infringement</h2>
        <p className="text-body">
          If you believe any content on the Conquer Life app infringes the
          copyright in a work that you own, please submit a notification
          alleging such infringement (“DMCA Takedown Notice”) to Conquer Life
          Co. The Takedown Notice must include the following:
          <ul>
            <li>
              A physical or electronic signature of a person authorized to act
              on behalf of the owner of an exclusive right that is allegedly
              infringed;
            </li>
            <li>
              Identification of the copyrighted work claimed to have been
              infringed, or, if multiple copyrighted works at a single online
              site are covered by a single notification, a representative list
              of such works;
            </li>
            <li>
              Identification of the material claimed to be infringing or to be
              the subject of infringing activity and that is to be removed or
              access disabled and information reasonably sufficient to permit
              the service provider to locate the material;
            </li>
            <li>
              Information reasonably sufficient to permit the service provider
              to contact you, such as an address, telephone number, and, if
              available, an electronic mail;
            </li>
            <li>
              A statement that you have a good faith belief that use of the
              material in the manner complained of is not authorized by the
              copyright owner, its agent, or the law; and
            </li>
            <li>
              A statement that, under penalty of perjury, the information in the
              notification is accurate and you are authorized to act on behalf
              of the owner of the exclusive right that is allegedly infringed.
            </li>
          </ul>
          Takedown Notices should be sent to Conquer Life Co. via email at
          copyright@conquerlife.io. As of now, Conquer Life Co. does not have a
          designated Copyright Agent. If you wish to reach out to Conquer Life
          Co. via other methods, you can write to: Conquer Life Co., Attn:
          Copyright Infringement Claims, 123 Main Street, Chicago, Illinois,
          60601.
        </p>

        <h2 className="text-heading">XIII. Third Party App Store</h2>
        <p className="text-body">
          The following additional terms and conditions apply if you download
          the Conquer Life App from a Third Party Store. To the extent that the
          other terms and conditions of these Terms are less restrictive than,
          or otherwise conflict with, the terms and conditions of this Section,
          the more restrictive or conflicting terms and conditions in this
          Section will apply, but solely with respect to the Conquer Life App
          and the Third Party Store. You acknowledge and agree that:
          <ul>
            <li>
              These Terms are concluded solely between you and Conquer Life Co.
              and not with the providers of the Third Party Store, and Conquer
              Life Co. (and not the Third Party Store providers) is solely
              responsible for the App and its content. To the extent that these
              Terms provide for usage rules for the App which are less
              restrictive or in conflict with the applicable terms of service of
              the Third Party Store from which you obtain the App, the more
              restrictive or conflicting term of the Third Party Store will take
              precedence and will apply.
            </li>
            <li>
              The Third Party Store provider has no obligation whatsoever to
              provide any maintenance and support services with respect to the
              App. Conquer Life Co. is solely responsible for any product
              warranties, whether expressed or implied by law, to the extent not
              effectively disclaimed. The Third Party Store provider will have
              no warranty obligation whatsoever with respect to the App, and any
              other claims, losses, liabilities, damages, costs, or expenses
              attributable to any failure to conform to any warranty will be the
              sole responsibility of Conquer Life Co.
            </li>
            <li>
              Conquer Life Co., not the Third Party Store provider, is
              responsible for addressing any claims you or any third party may
              have relating to the App or your possession and/or use of the App,
              including, but not limited to: (i) product liability claims; (ii)
              any claim that the App fails to conform to any applicable legal or
              regulatory requirement; (iii) claims arising under consumer
              protection or similar legislation; and/or (iv) intellectual
              property infringement claims.
            </li>
            <li>
              The Third Party Store provider and its subsidiaries are
              third-party beneficiaries of these Terms, and, upon your
              acceptance of these Terms, the Third Party Store provider from
              whom you obtained the App will have the right (and will be deemed
              to have accepted the right) to enforce these Terms against you as
              a third-party beneficiary thereof.
            </li>
          </ul>
          In the event of a conflict between a Third Party Store’s or mobile
          carrier’s applicable terms and conditions and these Terms, the terms
          and conditions of the Third Party Store or mobile carrier shall govern
          and control. Conquer Life Co. is not responsible and has no liability
          whatsoever for third-party goods or services you obtain through a
          Third Party Store or mobile carrier. We encourage you to make whatever
          investigation you feel necessary or appropriate before proceeding with
          any online transaction with any of these third parties.
        </p>

        <h2 className="text-heading">XIV. Dispute Resolution</h2>
        <p className="text-body">
          Please read the following arbitration agreement in this section
          (“Arbitration Agreement”) carefully. This Arbitration Agreement
          requires you and Conquer Life Co. to resolve disputes by binding
          arbitration instead of in court, and limits the manner in which we may
          seek relief from each other.
          <ol>
            <li>
              <b>When Does This Arbitration Agreement Apply?</b>
              <br></br> This Arbitration Agreement applies to any disputes or
              claims of any kind whatsoever (whether based in contract, tort,
              statute, regulation, ordinance, fraud, misrepresentation, or any
              other legal or equitable theory) between you and Conquer Life Co.
              arising out of or relating to the Terms, prior versions of the
              Terms, your use of our App, or any other aspect of your
              relationship with Conquer Life Co. It requires that, and by
              entering into these Terms you and Conquer Life Co. agree, that
              such disputes or claims will be resolved by binding arbitration,
              rather than in court, except that (i) you or Conquer Life Co. may
              assert individual claims in small claims court if your claims
              qualify; and (ii) you or Conquer Life Co. may seek equitable
              relief in court for infringement or misuse of intellectual
              property rights.
            </li>
            <li>
              <b>Notice of Dispute and Informal Resolution</b>
              <br></br> Before beginning the arbitration process, you and
              Conquer Life Co. agree to first notify one another of the dispute
              in writing at least 60 days in advance of initiating an
              arbitration. Notice to Conquer Life Co. must be sent by letter to
              our registered address: Conquer Life Co., 2136 W. North Ave #1W,
              Chicago, 60647, Illinois, USA, and must provide your name, current
              email address, mailing address, and telephone number, as well as
              the name, email address, and telephone number associated with your
              Conquer Life account (if different from your current information);
              and describe the nature of the claim and the specific relief being
              sought.
              <br></br>
              You and Conquer Life Co. agree to meet and confer, via
              teleconference or videoconference, in a good faith effort to
              informally resolve any claim or dispute covered by this
              Arbitration Agreement. If either party is represented by counsel,
              that counsel may participate in the informal dispute resolution
              conference. During this process, you may be provided with an offer
              of judgment. A party defending against a claim may serve on an
              opposing party an offer to allow judgment on specified terms, with
              the costs then accrued. If the judgment that the offeree finally
              obtains is not more favorable than the unaccepted offer, the
              offeree must pay the costs incurred after the offer was made. All
              offers, promises, conduct, and statements made in the course of
              the informal dispute resolution process by any party, its agents,
              employees, and attorneys are confidential and not admissible for
              any purpose in any subsequent proceeding, provided that evidence
              that is otherwise admissible or discoverable shall not be rendered
              inadmissible or non-discoverable as a result of its use in the
              informal dispute resolution process.
              <br></br>
              The informal dispute resolution conference shall occur within 60
              days of receipt of the written notice described above unless an
              extension is mutually agreed upon. If, after participating in that
              conference, the parties are unable to resolve the dispute, the
              claimant may commence an arbitration in accordance with this
              Agreement. Completion of this informal dispute resolution is a
              condition precedent to filing any demand for arbitration. Failure
              to do so is a breach of this Agreement, and no demand for
              arbitration shall be valid unless such written notice is provided
              and good faith discussions have been conducted.
              <br></br>
              Any statute of limitations will be tolled while the parties engage
              in the informal dispute resolution process described in this
              section.
            </li>
            <li>
              <b>How Do You Start the Arbitration Process?</b>
              <br></br> If you and Conquer Life Co. are unable to resolve the
              dispute within 60 days, either party may proceed to file a claim
              for arbitration. To begin the arbitration process, you or Conquer
              Life Co. must submit notice by certified mail of the claim with an
              individualized arbitration demand. To be valid, the demand must
              contain the name of the claiming party (you or Conquer Life Co.),
              your or Conquer Life Co.’s mailing address, the email address or
              phone number associated with your Conquer Life account (if
              applicable), and a detailed description of the dispute and the
              relief sought. Notice to Conquer Life Co. must be submitted to our
              registered address: Conquer Life Co., 3100 N. Lake Shore Dr., #908
              Chicago, IL 60657 United States.
            </li>
            <li>
              <b>What Are the Rules of Arbitration?</b>
              <br></br>
              The Federal Arbitration Act (“FAA”) governs this Arbitration
              Agreement and applies to the interpretation and enforcement of
              this Arbitration Agreement. If the FAA is found not to apply to
              any issue regarding the interpretation or enforcement of this
              Arbitration Agreement, that issue shall be determined by Illinois
              law, notwithstanding choice-of-law principles. The applicable
              arbitration provider depends on where you live. The arbitration
              will be administered by a recognized arbitration provider under
              its most current arbitration rules and procedures, or an
              alternative arbitral forum as agreed upon by the parties. If the
              parties cannot agree on an appropriate alternative arbitration
              provider, then the parties will ask a court of competent
              jurisdiction to appoint an arbitrator. The initiating party must
              pay all filing fees for the arbitration. Your and Conquer Life
              Co.’s responsibility to pay other administrative and arbitrator
              costs will be as set forth in the applicable arbitration
              provider’s rules, unless the arbitrator determines the claims are
              frivolous. If a claim is determined to be frivolous, the claimant
              is responsible for reimbursing the respondent for its portion of
              all such administrative, hearing, and/or other fees incurred as a
              result of the frivolous claim. You may qualify for a waiver of
              certain arbitration costs under the applicable arbitration
              provider’s rules or other applicable law. If you meet the standard
              for proceeding in forma pauperis in federal court, Illinois state
              court, or the courts of your state of residence, cannot obtain a
              waiver from the arbitration provider of any filing fees you are
              required to pay, and the arbitration provider refuses to
              administer the arbitration without your payment of said fees,
              Conquer Life Co. will pay the filing fees for you.
            </li>
            <li>
              <b>What Can the Arbitrator Decide? </b>
              <br></br>The arbitrator has the exclusive authority to resolve any
              and all threshold arbitrability issues, including whether this
              Arbitration Agreement is applicable, enforceable, or
              unconscionable. Courts, however, shall have the exclusive
              authority to determine (i) whether any provision of this
              Arbitration Agreement should be severed and the consequences of
              said severance, (ii) enforceability of any or all mass arbitration
              procedures, (iii) whether you have complied with conditions
              precedent to arbitration, and (iv) whether an arbitration provider
              is available to hear the arbitration(s) under this Agreement. The
              arbitrator will have the authority to grant motions dispositive of
              all or part of any claim. The arbitrator will have the authority
              to award monetary damages and to grant any non-monetary remedy or
              relief available under applicable law. The arbitrator will issue a
              written award and statement of decision describing the essential
              findings and conclusions on which the award is based, including
              the calculation of any damages awarded. The arbitrator has the
              same authority to award relief that a judge in a court of law
              would have. The award of the arbitrator is final and binding upon
              you and Conquer Life Co. Pursuant to and in conformance with this
              Agreement, any original action to compel arbitration under Section
              4 of the FAA (or analogous state law) must be brought in a State
              or Federal Court located in Cook County, Illinois.
            </li>
            <li>
              <b>No Jury Trials</b>
              <br></br>
              By agreeing to arbitration, YOU AND CONQUER LIFE CO. ARE EACH
              AGREEING TO WAIVE THEIR RIGHTS TO A JURY TRIAL. Instead, you and
              Conquer Life Co. are electing that all claims and disputes will be
              resolved by arbitration under this Arbitration Agreement, except
              as described above. An arbitrator can award the same damages and
              relief as a court and must follow this Agreement as a court would.
              However, there is no judge or jury in arbitration, and court
              review of an arbitration award is subject to very limited review.
            </li>
            <li>
              <b>One at a Time</b>
              <br></br>
              All claims and disputes within the scope of this Arbitration
              Agreement MUST BE ARBITRATED ON AN INDIVIDUAL BASIS AND NOT ON A
              CLASS OR COLLECTIVE BASIS, AND YOU AND CONQUER LIFE CO. GIVE UP
              YOUR RIGHTS TO PARTICIPATE IN A CLASS ACTION OR ANY OTHER CLASS
              PROCEEDING. Only relief that would be permitted in an individual
              lawsuit is available, and claims of more than one customer or user
              cannot be arbitrated or consolidated with those of any other
              customer or user. The arbitration proceeding will not be
              consolidated with any other matters or joined with any other cases
              or parties. If a decision is issued stating that applicable law
              precludes enforcement of any of this subsection’s limitations as
              to a given claim for relief, then the claim must be severed from
              the arbitration and brought into the State or Federal Courts
              located in Cook County, Illinois. All other claims shall be
              arbitrated. This subsection does not prevent you or Conquer Life
              Co. from participating in a class-wide settlement of claims.
            </li>
            <li>
              <b>Offer of Judgment</b>
              <br></br>
              At least 14 days before the date set for the arbitration hearing,
              any party may serve an offer in writing upon the other party to
              allow judgment on specified terms. If the offer made by one party
              is not accepted by the other party, and the other party fails to
              obtain a favorable award, the other party shall not recover any
              post-offer costs to which they otherwise would be entitled and
              shall pay the offering party’s costs from the time of the offer.
            </li>
            <li>
              <b>Opt-Out</b>
              <br></br> You may opt out of this Arbitration Agreement by sending
              written notice of your decision to opt out to:
              info@conquerlifeco.com, within 31 days after first becoming
              subject to this Arbitration Agreement. Your notice must include
              your name, your Conquer Life username (if any), the email address
              and/or phone number associated with your Conquer Life account (if
              any), and a clear statement that you want to opt out of this
              Arbitration Agreement. The decision to opt out of this Arbitration
              Agreement will not affect any other provisions of the Terms or
              your ability to use the Conquer Life app.
            </li>
            <li>
              <b>Miscellaneous</b>
              <br></br> This Arbitration Agreement will survive any termination
              of your relationship with Conquer Life Co. The arbitrator will
              determine the enforceability of this Arbitration Agreement.
            </li>
          </ol>
        </p>

        <h2 className="text-heading">XV. Use Of Third-Party Integrations</h2>
        <p className="text-body">
          As of now, Conquer Life does not utilize any third-party integrations
          within our App. If this changes in the future and we incorporate
          third-party features or services, we will update these Terms
          accordingly to reflect any additional terms or conditions that may
          apply.
        </p>

        <h2 className="text-heading">XVI. Termination And Remedies</h2>
        <p className="text-body">
          These Terms commence on the date you accept them (as described in the
          preamble) and continue until terminated in accordance with the terms
          herein.
          <br></br>
          <br></br>
          You can delete your Account at any time by logging into the App, going
          to the “Settings” tab (the gear icon), and following the instructions
          to terminate your account. If you delete your account, your access
          ends immediately.
          <br></br>
          <br></br>
          In the event that Conquer Life Co. determines, in its sole discretion,
          that you have breached any portion of these Terms, have misused the
          App, or have otherwise demonstrated conduct that Conquer Life Co.
          regards as inappropriate or unlawful (whether on or off the App),
          Conquer Life Co. reserves the right to: (a) warn you via email (to any
          email addresses you have provided to Conquer Life Co.) that you have
          violated the Terms; (b) delete your User Content; (c) discontinue your
          Account; (d) discontinue your subscription(s) without refund; (e)
          notify and/or send your User Content to and/or fully cooperate with
          the proper law enforcement authorities for further action; and/or (f)
          pursue any other action that Conquer Life Co. deems to be appropriate.
          You agree that all terminations for cause shall be made in Conquer
          Life Co.’s sole discretion and that Conquer Life Co. shall not be
          liable to you or any third party for any termination of your Account.
          <br></br>
          <br></br>
          Termination of these Terms or your Account includes the removal of
          access to your Account and all related information and content
          associated with or inside your Account.
          <br></br>
          <br></br>
          If your account is terminated by you or by Conquer Life Co. for any
          reason, all provisions of these Terms, which by their nature should
          survive, shall survive the termination of these Terms, including,
          without limitation, the Arbitration Agreement, ownership provisions,
          warranty disclaimers, and limitation of liability. Your information
          will be maintained and deleted in accordance with our Privacy Policy.
        </p>

        <h2 className="text-heading">XVII. Miscellaneous</h2>
        <p className="text-body">
          There are a few more things we need to mention before you can use the
          Conquer Life App. These Terms, which we may amend from time to time,
          constitute the entire agreement between you and Conquer Life Co. The
          Terms supersede all previous agreements, representations, and
          arrangements between us (written or oral), excluding the Privacy
          Policy. Nothing in this clause shall limit or exclude any liability
          for fraudulent misrepresentation.
          <br></br>
          <br></br>
          Conquer Life Co. has taken reasonable steps to ensure the currency,
          availability, correctness, and completeness of the information
          contained on Conquer Life and provides that information on an "as is,"
          "as available" basis. Conquer Life Co. does not give or make any
          warranty or representation of any kind about the information contained
          on Conquer Life, whether express or implied. Use of Conquer Life and
          the materials available on it is at your sole risk. Conquer Life Co.
          is not responsible for any loss arising from the transmission, use of
          data, or inaccurate Member Content.
          <br></br>
          <br></br>
          You are responsible for taking all necessary precautions to ensure
          that any material you may obtain from Conquer Life is free of viruses
          or other harmful components. You accept that Conquer Life will not be
          provided uninterrupted or error-free, that defects may not be
          corrected, or that Conquer Life Co., or the server that makes it
          available, are free of viruses or bugs, spyware, Trojan horses, or any
          similar malicious software. Conquer Life Co. is not responsible for
          any damage to your computer hardware, computer software, or other
          equipment or technology, including, but without limitation, damage
          from any security breach or from any virus, bugs, tampering, fraud,
          error, omission, interruption, defect, delay in operation or
          transmission, computer line or network failure, or any other technical
          or other malfunction.
          <br></br>
          <br></br>
          The communications between you and Conquer Life Co. may take place via
          electronic means, whether you use the App or send Conquer Life Co.
          emails, or whether Conquer Life Co. posts notices in the App or
          communicates with you via email. For contractual purposes, you (a)
          consent to receive communications from Conquer Life Co. in electronic
          form; and (b) agree that all terms and conditions, agreements,
          notices, disclosures, and other communications that Conquer Life Co.
          provides to you electronically satisfy if it were to be in writing.
          The foregoing does not affect your statutory rights, including but not
          limited to the Electronic Signatures in Global and National Commerce
          Act at 15 U.S.C. Sec. 7001 et. seq. This agreement to electronic
          communications does not establish permission for activity-reminder
          SMS, as explained in Section VII.
          <br></br>
          <br></br>
          We may update these Terms from time to time.
          <br></br>
          <br></br>
          As Conquer Life grows, we might have to make changes to these Terms,
          so we reserve the right to modify, amend, or change the Terms at any
          time (a “Change”). If we do this, the Changes will be posted on this
          page, and we will indicate the Effective Date of the updates at the
          bottom of the Terms. In certain circumstances, we may send an email to
          you notifying you of a Change. It’s also possible that we might ask
          you to agree to our Changes, but we’ll let you know. You should
          regularly check this page for notice of any Changes – we want our
          users to be as informed as possible.
          <br></br>
          <br></br>
          Your continued use of Conquer Life following any Change constitutes
          your acceptance of the Change, and you will be legally bound by the
          new updated Terms. If you do not accept any Changes to the Terms, you
          should stop using Conquer Life immediately.
          <br></br>
          <br></br>
          <b>Additional items:</b>
          <ul>
            <li>
              If, for any reason, any of the Terms are declared illegal,
              invalid, or otherwise unenforceable by a court of competent
              jurisdiction, then to the extent that term is illegal, invalid, or
              unenforceable, it shall be severed and deleted from the Terms, and
              the remainder of the Terms shall survive, remain in full force and
              effect, and continue to be binding and enforceable.
            </li>
            <li>
              No failure or delay in exercising any right, power, or privilege
              under the Terms shall operate as a waiver of such right or
              acceptance of any variation of the Terms, nor shall any single or
              partial exercise by either party of any right, power, or privilege
              preclude any further exercise of the right or the exercise of any
              other right, power, or privilege.
            </li>
          </ul>
          You represent and warrant that:
          <ul>
            <li>
              You are not located in a country that is subject to a U.S.
              Government embargo or that has been designated by the U.S.
              Government as a “terrorist-supporting” country; and
            </li>
            <li>
              You are not listed on any U.S. Government list of prohibited or
              restricted parties.
            </li>
          </ul>
          By using the App, you agree and acknowledge that Conquer Life is a
          global app operating through servers located in a number of countries
          around the world, including the United States. If you live in a
          country with data protection laws, the storage of your personal data
          may not provide you with the same protections as you enjoy in your
          country of residence. By submitting your personal information or by
          choosing to upgrade the services you use, or by making use of the
          applications available on Conquer Life, you agree to the transfer of
          your personal information to, and storage and processing of your
          personal information in, any such countries and destinations.
          <br></br>
          <br></br>
          The App may contain links to third-party websites or resources. In
          such cases, you acknowledge and agree that we are not responsible or
          liable for:
          <ul>
            <li>
              The availability or accuracy of such websites or resources; or
            </li>
            <li>
              The content, products, or services on or available from such
              websites or resources.
            </li>
          </ul>
          Links to such websites or resources do not imply any endorsement. You
          acknowledge sole responsibility for and assume all risk arising from
          your use of any such websites or resources. Framing, in-line linking,
          or other methods of association with the App are expressly prohibited
          without first obtaining our prior written approval.
          <br></br>
          <br></br>
          These Terms, and any rights and licenses granted hereunder, may not be
          transferred or assigned by you, but may be assigned by us without
          restriction.
          <br></br>
          <br></br>
          In the event there is a discrepancy between this English language
          version and any translated copies of the Terms, the English version
          shall prevail.
          <br></br>
          <br></br>
          If you have any questions, complaints, or claims with respect to the
          App, please contact us using in-app Feedback section.
        </p>

        <h2 className="text-heading">XVIII. Governing Law And Forum</h2>
        <p className="text-body">
          Subject to Section 13(3) and any mandatory laws that may apply in the
          country in which you reside, your access to the App, Our Content, and
          any Member Content, any claims arising from or related to your
          relationship with Conquer Life Co., and these Terms are governed and
          interpreted by the laws of the State of Illinois. All claims arising
          out of or relating to these Terms and/or your relationship with
          Conquer Life Co. that for whatever reason are not submitted to
          arbitration, and all claims or cases challenging the enforceability or
          applicability of the arbitration provisions herein, will be litigated
          exclusively in the federal or state courts of Cook County, Illinois.
          You agree that such courts shall have personal jurisdiction and venue
          and waive any objection based on an inconvenient forum. You agree that
          you will not file or participate in a class action against us.
        </p>

        <h2 className="text-heading">XIX. The Conquer Life Company</h2>
        <p className="text-body">
          The Terms constitute a binding legal agreement between you as the user
          (“you”) and Conquer Life Co. (“we” or “us”). Conquer Life Co. is the
          sole entity operating the Conquer Life app and website, and there are
          no other divisions or subsidiaries involved.
          <br></br>
          <br></br>
          <b>Effective Date</b>
          The Terms were last updated on: October 13th, 2026.
        </p>
      </div>
    </div>
  );
};

const styles = {
  page: {
    flex: 1,
    backgroundColor: "#FFFFFF",
  },
  header: {
    display: "flex",
    alignItems: "center",
    borderBottom: "1px solid black",
    height: "60px",
    padding: "0 15px",
    boxSizing: "border-box",
  },
  logo: {
    width: "40px",
    height: "40px",
    marginRight: "15px",
  },
  headerTitle: {
    fontSize: "26px",
    fontWeight: "bold",
    color: "black",
    margin: 0,
  },
  container: {
    padding: "2rem",
  },
  heading: {
    textAlign: "center",
    fontSize: "2.5rem",
    color: "#333",
    marginBottom: "2rem",
  },
};

export default TermsAndConditions;
